export default function downloadListFilter() {
	let downloadSearch = $('.downloadSearch');

	let form = $('.downloads .form');

	function filterDownloads(form, page = null) {
		$('.modalLoader').show();
		$.ajax({
			type: form.attr('method'),
			url: form.attr('action'),
			data: form.serialize() + (page ? "&p=" + page + "&l=8" : null),
			dataType: "json",
			success: function (data) {
				$('.modalLoader').hide();
				let valSearch = '';
				let inputSearch = $('.downloads .downloads__search');
				if (form.find('.downloads__search').val().length > 0) {
					valSearch = `${jsi18n.to} <span class="colorPrimary">"${inputSearch.val()}"</span>`;
				} else {
					inputSearch.val('');
				}

				let content = `<h3 class="downloads__resultQtd">${jsi18n.have_found} ${data.total} ${jsi18n.results} ${valSearch}</h3><p class="downloads__textSelect">${jsi18n.select_category}</p><div class="row">`;

				$.each(data.contents, function (key, el) {

					content += `<div class="col-md-3 col-6">
									<div class="downloads__iten">
										<div class="downloads__iten__bd">
											<div class="downloads__iten__icon"><img src="${el.img}/${el.icon}.png" alt="Download"></div>
											<p class="downloads__iten__size">(${el.size})</p>
											<p class="downloads__iten__title">${el.title}</p>
										</div>
										`;
										console.log(el.exist);
										if(!el.exist){
											content += 	`<button data-btndownload class="btnDefault category-main-color l-d" title="${jsi18n.select}" data-toggle="tooltip" data-placement="top" data-downloadcart="${el.url}" data-id="${el.id}"><i class="fas fa-download"></i>${jsi18n.select}</button>`;
										} else {
											content += 	`<button data-btndownload class="btnDefault category-main-color l-d active" title="${jsi18n.select_active}" data-toggle="tooltip" data-placement="top" data-downloadcart="${el.url}" data-id="${el.id}"><i class="fas fa-download"></i>${jsi18n.select_active}</button>`;
										}
						content += `</div>
								</div>`;

				})
				content += `</div>`;
				downloadSearch.html(content).fadeIn();
				$('#downloads .downloadPagination').html(data.pagination);
			}
		});
	}

	$('.downloads .form').on('submit', function (e) {
		e.preventDefault();
		filterDownloads($(this), 1);
	})

	$('.perpage-select').on('change', function (event) {
		if ($(this).val()) {
			location.href = $(this).val();
		}
	});
	$('#downloads').on('click', '.pager.filter a', function (e) {
		e.preventDefault();
		var page = $(this).data('page');
		filterDownloads($('.downloads .form'), page);
	});

	$(window).on("load", function(){
		filterDownloads($('.downloads .form'), 1);
	});
}